import MediaGallery from "../../Components/MediaGallery";
import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Title from "../../Components/Title";
import {
  getLastParameter,
  getToken,
  requestErrorHandler,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
const server = EnvSettings.server;

export default function Checklist(props) {
  const classes = useStyles();
  const device_id = props.device_id || getLastParameter();
  const [checklistURL, setChecklistURL] = useState();
  const [loading, setLoading] = useState(false);
  const [listError, setListError] = useState(false);
  const listRequest = useRef();
  const [files, setFiles] = useState([]);
  const [fileToDelete, setFileToDelete] = useState();
  const { t } = useTranslation();

  const fileUploadRef = useRef();
  const checklistInputId = "checklist-upload-file";

  const dispatch = useDispatch();

  const getChecklist = () => {
    if (listRequest.current) listRequest.current.abort();
    const controller = new AbortController();
    listRequest.current = controller;
    setLoading(true);
    setListError(false);
    setChecklistURL();
    const requestOptions = {
      method: "POST",
      signal: controller.signal,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        deviceid: device_id,
      }),
    };
    fetch(server + "/get_checklist", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (controller.signal.aborted) return;
        setListError(!!result.error);
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          if (result.files) {
            setChecklistURL(result);
          }
        }
      }).catch(() => {
        if (!controller.signal.aborted) setListError(true);
      }).finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
  };

  useEffect(() => {
    getChecklist();
    return () => { if (listRequest.current) listRequest.current.abort(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [device_id, dispatch]);

  const uploadChecklist = (e) => {
    if (!files.length) {
      return;
    }
    const data = new FormData();
    data.append("token", getToken());
    files.forEach((element) => {
      data.append("checklist", element);
    });
    data.append("device_id", device_id);
    fetch(server + "/upload_checklist", {
      method: "POST",
      // headers: {
      //   "content-type": file.type,
      //   "content-length": `${file.size}`, // 👈 Headers need to be a string
      // },
      body: data,
    })
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        dispatch(showPopupSnackbar(result));
        if (!result.error) {
          getChecklist();
          setFiles([]);
          fileUploadRef.current.value = null;
        }
      });
  };

  const removeChecklist = () => {
    if (!fileToDelete || !device_id) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        filename: fileToDelete,
        device_id: device_id,
      }),
    };
    fetch(server + "/delete_checklist", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          dispatch(showPopupSnackbar(result));
        }

        getChecklist();
      });
  };

  const handleClose = () => {
    setFileToDelete(undefined);
  };

  return (
    <Grid container spacing={3}>
      <Dialog
        open={fileToDelete ? true : false}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("delete")} {fileToDelete}?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("cancel")}
          </Button>
          <Button
            onClick={() => {
              removeChecklist();
              handleClose();
            }}
            color="primary"
            autoFocus
          >
            {t("delete")}
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container spacing={3} item xs={12}>
        <Grid item xs={12}>
          <Title>{t("checklists")}</Title>
        </Grid>
        {loading ? (
          <Grid item xs={12}><CircularProgress size={24} aria-label={t("mediaPreview.loading")} /></Grid>
        ) : listError ? (
          <Grid item xs={12}>
            <Typography color="error" role="alert">{t("mediaPreview.listFailed")}</Typography>
            <Button onClick={getChecklist}>{t("mediaPreview.retry")}</Button>
          </Grid>
        ) : checklistURL?.attachments?.length ? (
          <Grid item xs={12}>
            <MediaGallery attachments={checklistURL.attachments}
              resource={{ type: "checklist" }} deviceid={device_id} onDelete={setFileToDelete} />
          </Grid>
        ) : (
          <Grid item><Typography>{t("noChecklistAvailable")}</Typography></Grid>
        )}
      </Grid>
      <Grid container item xs={12} sm={6}>
        <Grid item xs={12}>
          <Title>{t("uploadNewChecklist")}</Title>
        </Grid>
        <Grid item>
          <input
            accept="image/*,.pdf"
            className={classes.input}
            id={checklistInputId}
            type="file"
            multiple
            onChange={(e) => {
              if (e.target.files) {
                setFiles(Array.prototype.slice.call(e.target.files));
              }
            }}
            ref={fileUploadRef}
          />
        </Grid>
        <Grid item>
          <label htmlFor={checklistInputId}>
            <Button
              variant="outlined"
              disabled={!files.length ? true : false}
              onClick={uploadChecklist}
            >
              {t("uploadChecklist")}
            </Button>
          </label>
        </Grid>
      </Grid>
    </Grid>
  );
}
